module.exports = __webpack_public_path__ + "img/hongbao_img03.4bd49b60.png";